import { VacationService } from "../../api/vacation-service";
import { EOSService } from "../../api/eos-service";

const state = {};

const getters = {};

const actions = {
    async GetWebVacationTypeList() {
        return await EOSService.makeRequest(VacationService.GetWebVacationTypeList())
    },
    async GetAllVacationTypeList() {
        return await EOSService.makeRequest(VacationService.GetAllVacationTypeList())
    },
    async AddVacation(state, { params }) {
        if (!params.get('PersonnelNo')) {
            var perno = state.rootState.auth.auth.username;
            params.append('PersonnelNo', perno);
        }
        return await EOSService.makeRequest(VacationService.AddVacation(params))
    },
    async PersonVacationList(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        if (!params.get('perno')) {
            params.append('perno', perno);
        }
        params.append('sortType', 'Desc');
        params.append('sortExpression', 'beginDate');
        return await EOSService.makeRequest(VacationService.PersonVacationList(params))
    },
    async GetTotalVacationRemainDetail(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        if (!params.get('perno')) {
            params.append('perno', perno);
        }

        return await EOSService.makeRequest(VacationService.GetTotalVacationRemainDetail(params))
    },
    async GetVacationRemainDetail(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        if (!params.get('perno')) {
            params.append('perno', perno);
        }

        return await EOSService.makeRequest(VacationService.GetVacationRemainDetail(params))
    },
    async GetVacationDetailForPerson(state, { params }) {
        if (!params.get('perno')) {
            var perno = state.rootState.auth.auth.username;
            params.append('perno', perno);
        }
        return await EOSService.makeRequest(VacationService.GetVacationDetailForPerson(params))
    },
    async GetVacationDetailForAdmin(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params.append('adminPerno', perno);
        return await EOSService.makeRequest(VacationService.GetVacationDetailForAdmin(params))
    },
    async OprationOnVacationArchive(state, { params }) {
        return await EOSService.makeRequest(VacationService.OprationOnVacationArchive(params))
    },
    async OprationOnVacationRequest(state, { params }) {
        debugger
        return await EOSService.makeRequest(VacationService.OprationOnVacationRequest(params))
    },
    async GetVacationListForAdmins(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params['adminPerno'] = perno;
        return await EOSService.makeRequest(VacationService.GetVacationListForAdmins(params))
    },
    async GetVacationApproveDegree(state, { approveParams }) {
        var perno = state.rootState.auth.auth.username;
        approveParams['adminPerno'] = perno;
        return await EOSService.makeRequest(VacationService.GetApproveDegree(approveParams))
    },
    

    async GetRemainMorakhasiUntilNow(state, { GetRemainMorakhasiUntilNowParams }) {
        var params = new URLSearchParams()
        params.append('perno',GetRemainMorakhasiUntilNowParams.perno)
        params.append('date',GetRemainMorakhasiUntilNowParams.date)
        params.append('year',GetRemainMorakhasiUntilNowParams.year)
        return await EOSService.makeRequest(VacationService.GetRemainMorakhasiUntilNow(params))
    },
    async GetHourlyVacationCountAndLength(state, { GetHourlyVacationCountAndLengthParams }) {
        var params = new URLSearchParams()
        params.append('perno',GetHourlyVacationCountAndLengthParams.perno)
        params.append('date',GetHourlyVacationCountAndLengthParams.date)
        params.append('year',GetHourlyVacationCountAndLengthParams.year)
        return await EOSService.makeRequest(VacationService.GetHourlyVacationCountAndLength(params))
    },
    async GetPeriodVacationDetail(state, { GetPeriodVacationDetailParams }) {
        var params = new URLSearchParams()
        params.append('perno',GetPeriodVacationDetailParams.perno)
        params.append('period',GetPeriodVacationDetailParams.period)
        params.append('year',GetPeriodVacationDetailParams.year)
        params.append('isPeriod',GetPeriodVacationDetailParams.isPeriod)
        return await EOSService.makeRequest(VacationService.GetPeriodVacationDetail(params))
    },
};

const mutations = {};

export default {
    state,
    getters,
    actions,
    mutations
}